<h2>You're all set! <i class="pi pi-check-circle" style="color: #4dc962; font-size: 2.5rem"></i></h2>
<h3>See you at the range</h3>

<div class="flex justify-content-start ml-2">
  <div class="flex flex-column gap-1">
    <div><i class="pi pi-receipt icon"></i> Reference # {{orderId}}</div>
    <div><i class="pi pi-map-marker icon"></i> {{selectedStation?.Location?.Desc}}</div>
    <div><i class="pi pi-bullseye icon"></i> {{selectedStation?.Name}}</div>
    <div><i class="pi pi-calendar-clock icon"></i> {{selectedDate?.toLocaleDateString()}}, {{selectedTime?.formatedTimeAndRate}}</div>
    <div><i class="pi pi-clock icon"></i> {{duration}} Hours</div>
    <div><i class="pi pi-user icon"></i> {{selectedAmountOfGuests}} Guests</div>
    <div><i class="pi pi-clipboard icon"></i> Notes: {{Notes}}</div>
  </div>
</div>
